export default {
  "content": "<path d=\"M5 19h3v2H4a1 1 0 01-1-1v-4h2v3zM14 21h-4v-2h4v2zM21 20a1 1 0 01-1 1h-4v-2h3v-3h2v4zM5 14H3v-4h2v4zM21 14h-2v-4h2v4zM8 5H5v3H3V4a1 1 0 011-1h4v2zM20 3a1 1 0 011 1v4h-2V5h-3V3h4zM14 5h-4V3h4v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};